(() => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuButton && mobileNav) {
    const closeMenu = () => {
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      mobileNav.inert = true;
      body.classList.remove('menu-open');
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
    };
    menuButton.addEventListener('click', () => {
      const open = !mobileNav.classList.contains('is-open');
      mobileNav.classList.toggle('is-open', open);
      mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
      mobileNav.inert = !open;
      body.classList.toggle('menu-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (open) mobileNav.querySelector('a')?.focus();
    });
    mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
  }

  const reveal = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: .12 });
    reveal.forEach(el => io.observe(el));
  } else {
    reveal.forEach(el => el.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-hero-carousel]').forEach(hero => {
    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const prev = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Math.max(4000, Number(hero.dataset.delay || 7000));
    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer;
    let touchStartX = 0;
    const show = newIndex => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      if (!reduceMotion) timer = window.setInterval(() => show(index + 1), delay);
    };
    prev?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    hero.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    hero.addEventListener('touchend', event => {
      const endX = event.changedTouches[0]?.clientX || 0;
      const delta = endX - touchStartX;
      if (Math.abs(delta) > 45) { show(index + (delta < 0 ? 1 : -1)); start(); }
    }, { passive: true });
    show(index);
    start();
  });

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const counter = gallery.querySelector('[data-gallery-current]');
    const stage = gallery.querySelector('.product-gallery__stage');
    if (!slides.length) return;
    let index = 0;
    let touchStartX = 0;
    const show = nextIndex => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(index + 1);
      thumbs[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    stage?.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    stage?.addEventListener('touchend', event => {
      const delta = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(delta) > 48) show(index + (delta < 0 ? 1 : -1));
    }, { passive: true });
    show(0);
  });

  document.querySelectorAll('.specs__groups').forEach(group => {
    const items = Array.from(group.querySelectorAll('.spec-group'));
    items.forEach(item => item.addEventListener('toggle', () => {
      if (!item.open || window.matchMedia('(min-width: 901px)').matches) return;
      items.forEach(other => { if (other !== item) other.open = false; });
    }));
  });

  document.querySelectorAll('[data-product-explorer]').forEach(explorer => {
    const frames = Array.from(explorer.querySelectorAll('[data-explorer-frame]'));
    const tilt = explorer.querySelector('[data-explorer-tilt]');
    const prev = explorer.querySelector('[data-explorer-prev]');
    const next = explorer.querySelector('[data-explorer-next]');
    const reset = explorer.querySelector('[data-explorer-reset]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let frameIndex = 0;
    let dragging = false;
    let lastX = 0;
    let dragRemainder = 0;

    const showFrame = newIndex => {
      if (!frames.length) return;
      frameIndex = (newIndex + frames.length) % frames.length;
      frames.forEach((frame, i) => {
        const active = i === frameIndex;
        frame.hidden = !active;
        frame.classList.toggle('is-active', active);
      });
    };
    const resetTilt = () => {
      if (!tilt) return;
      tilt.style.setProperty('--tilt-x', '0deg');
      tilt.style.setProperty('--tilt-y', '0deg');
      tilt.style.setProperty('--tilt-scale', '1');
    };
    const updateTilt = event => {
      if (!tilt || reduceMotion) return;
      const rect = explorer.getBoundingClientRect();
      const x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
      const y = Math.max(0, Math.min(rect.height, event.clientY - rect.top));
      const rotateY = ((x / rect.width) - .5) * 16;
      const rotateX = (.5 - (y / rect.height)) * 10;
      tilt.style.setProperty('--tilt-x', `${rotateX.toFixed(2)}deg`);
      tilt.style.setProperty('--tilt-y', `${rotateY.toFixed(2)}deg`);
      tilt.style.setProperty('--tilt-scale', '1.018');
    };

    explorer.addEventListener('pointerdown', event => {
      dragging = true;
      lastX = event.clientX;
      dragRemainder = 0;
      explorer.classList.add('is-dragging');
      explorer.setPointerCapture?.(event.pointerId);
    });
    explorer.addEventListener('pointermove', event => {
      if (frames.length && dragging) {
        dragRemainder += event.clientX - lastX;
        lastX = event.clientX;
        const threshold = Math.max(10, 34 - frames.length);
        if (Math.abs(dragRemainder) >= threshold) {
          showFrame(frameIndex + (dragRemainder < 0 ? 1 : -1));
          dragRemainder = 0;
        }
      } else if (tilt) updateTilt(event);
    });
    const stopDrag = event => {
      dragging = false;
      explorer.classList.remove('is-dragging');
      if (event?.pointerId != null && explorer.hasPointerCapture?.(event.pointerId)) explorer.releasePointerCapture?.(event.pointerId);
    };
    explorer.addEventListener('pointerup', stopDrag);
    explorer.addEventListener('pointercancel', stopDrag);
    explorer.addEventListener('pointerleave', event => { stopDrag(event); if (!frames.length) resetTilt(); });
    explorer.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showFrame(frameIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showFrame(frameIndex + 1); }
      if (event.key === 'Escape') { showFrame(0); resetTilt(); }
    });
    prev?.addEventListener('click', () => frames.length ? showFrame(frameIndex - 1) : tilt?.style.setProperty('--tilt-y', '-9deg'));
    next?.addEventListener('click', () => frames.length ? showFrame(frameIndex + 1) : tilt?.style.setProperty('--tilt-y', '9deg'));
    reset?.addEventListener('click', () => { showFrame(0); resetTilt(); });
    showFrame(0);
    resetTilt();
  });

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-button]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyButton = root.querySelector('.mobile-purchase-bar button[form]');
    const dataNode = root.querySelector('[data-variants-json]');
    if (!select || !dataNode) return;
    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch(e) { return; }
    const money = root.dataset.moneyFormat || '${{amount}}';
    const formatMoney = cents => {
      const value = (Number(cents || 0) / 100).toFixed(2);
      return money.replace('{{amount}}', value).replace('{{ amount }}', value);
    };
    const update = () => {
      const variant = variants.find(v => String(v.id) === String(select.value));
      if (!variant) return;
      if (price) price.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    };
    select.addEventListener('change', update);
    update();
  });

  const contactInterest = document.querySelector('[data-contact-interest]');
  if (contactInterest) {
    const requestedProduct = new URLSearchParams(window.location.search).get('product');
    if (requestedProduct && Array.from(contactInterest.options).some(option => option.value === requestedProduct)) {
      contactInterest.value = requestedProduct;
    }
  }

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    const panel = cartDrawer.querySelector('.cart-drawer__panel');
    const lines = cartDrawer.querySelector('[data-cart-lines]');
    const footer = cartDrawer.querySelector('[data-cart-footer]');
    const subtotal = cartDrawer.querySelector('[data-cart-subtotal]');
    const status = cartDrawer.querySelector('[data-cart-status]');
    const cartUrl = cartDrawer.dataset.cartUrl || '/cart';
    const addUrl = cartDrawer.dataset.cartAddUrl || '/cart/add';
    const changeUrl = cartDrawer.dataset.cartChangeUrl || '/cart/change';
    const currency = cartDrawer.dataset.currency || 'USD';
    let returnFocus;

    const jsonEndpoint = url => url.endsWith('.js') ? url : `${url}.js`;
    const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, char => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    })[char]);
    const formatCurrency = cents => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      }
    };
    const updateCounts = count => {
      document.querySelectorAll('[data-cart-count]').forEach(node => {
        node.textContent = String(count);
        if (node.classList.contains('cart-count')) node.classList.toggle('is-empty', count === 0);
      });
      document.querySelectorAll('[data-cart-open]').forEach(link => link.setAttribute('aria-label', `Cart with ${count} items`));
    };
    const renderCart = cart => {
      updateCounts(cart.item_count);
      if (subtotal) subtotal.textContent = formatCurrency(cart.total_price);
      footer?.classList.toggle('is-empty', cart.item_count === 0);
      if (!lines) return;
      if (!cart.items.length) {
        lines.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        return;
      }
      lines.innerHTML = cart.items.map((item, index) => {
        const image = item.featured_image?.url || item.image || '';
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? `<small>${escapeHtml(item.variant_title)}</small>` : '';
        const imageMarkup = image
          ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" width="184" height="208" loading="lazy">` : '';
        return `<article class="cart-drawer__line" data-cart-line="${index + 1}">
          ${imageMarkup}
          <div class="cart-drawer__line-copy">
            <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <span>${formatCurrency(item.final_price)}</span>
            <div class="cart-drawer__quantity" aria-label="Quantity">
              <button type="button" data-cart-quantity="${Math.max(0, item.quantity - 1)}" data-line="${index + 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-quantity="${item.quantity + 1}" data-line="${index + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <button class="cart-drawer__remove" type="button" data-cart-quantity="0" data-line="${index + 1}">Remove</button>
        </article>`;
      }).join('');
    };
    const getCart = async () => {
      const response = await fetch(jsonEndpoint(cartUrl), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be loaded.');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };
    const closeCart = () => {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('drawer-open');
      returnFocus?.focus();
    };
    const openCart = (trigger, refresh = true) => {
      returnFocus = trigger || document.activeElement;
      if (mobileNav?.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        mobileNav.setAttribute('aria-hidden', 'true');
        mobileNav.inert = true;
        body.classList.remove('menu-open');
        menuButton?.setAttribute('aria-expanded', 'false');
      }
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      body.classList.add('drawer-open');
      panel?.focus();
      if (refresh) getCart().catch(error => { if (status) status.textContent = error.message; });
    };

    document.querySelectorAll('[data-cart-open]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        openCart(link);
      });
    });
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', closeCart));
    cartDrawer.addEventListener('click', async event => {
      const button = event.target.closest('[data-cart-quantity]');
      if (!button) return;
      button.disabled = true;
      if (status) status.textContent = 'Updating cart.';
      try {
        const response = await fetch(jsonEndpoint(changeUrl), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(button.dataset.line), quantity: Number(button.dataset.cartQuantity) })
        });
        if (!response.ok) throw new Error('Cart could not be updated.');
        renderCart(await response.json());
        if (status) status.textContent = 'Cart updated.';
      } catch (error) {
        if (status) status.textContent = error.message;
        button.disabled = false;
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCart();
      if (event.key === 'Tab' && cartDrawer.classList.contains('is-open') && panel) {
        const focusable = Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    document.querySelectorAll('form.product-form').forEach(form => {
      form.addEventListener('submit', async event => {
        if (event.submitter?.closest('.shopify-payment-button')) return;
        event.preventDefault();
        const button = form.querySelector('[data-add-button]');
        const submitter = event.submitter;
        if (button) button.disabled = true;
        if (submitter && submitter !== button) submitter.disabled = true;
        if (status) status.textContent = 'Adding product to cart.';
        try {
          const response = await fetch(jsonEndpoint(addUrl), {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) {
            const result = await response.json().catch(() => ({}));
            throw new Error(result.description || 'This product could not be added.');
          }
          await getCart();
          if (status) status.textContent = 'Product added to cart.';
          openCart(button, false);
        } catch (error) {
          if (status) status.textContent = error.message;
          form.insertAdjacentHTML('beforeend', `<p class="product-form__error" role="alert">${escapeHtml(error.message)}</p>`);
        } finally {
          if (button) button.disabled = false;
          if (submitter && submitter !== button) submitter.disabled = false;
        }
      });
    });
  }

  /* SAHOVIA dialogs: certification, tracking and launch offer */
  const dialogReturnFocus = new WeakMap();
  const openDialog = (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    dialogReturnFocus.set(dialog, trigger || document.activeElement);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    body.classList.add('modal-open');
    window.setTimeout(() => dialog.querySelector('[data-dialog-close],input,button,a[href]')?.focus(), 40);
  };
  const closeDialog = dialog => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  document.querySelectorAll('[data-dialog-open]').forEach(trigger => {
    trigger.addEventListener('click', event => {
      const dialog = document.getElementById(trigger.dataset.dialogOpen);
      if (!dialog) return;
      event.preventDefault();
      openDialog(dialog, trigger);
    });
  });
  document.querySelectorAll('.sahovia-dialog').forEach(dialog => {
    dialog.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', () => closeDialog(dialog)));
    dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(dialog); });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('.sahovia-dialog[open]')) body.classList.remove('modal-open');
      dialogReturnFocus.get(dialog)?.focus?.();
      if (dialog.matches('[data-launch-dialog]')) {
        try { window.localStorage.setItem('sahovia-launch-seen', String(Date.now())); } catch (error) { /* storage is optional */ }
      }
    });
  });

  document.querySelectorAll('[data-product-video]').forEach(wrapper => {
    const video = wrapper.querySelector('[data-product-video-player]');
    const play = wrapper.querySelector('[data-product-video-play]');
    if (!video || !play) return;
    play.addEventListener('click', () => video.play().catch(() => {}));
    video.addEventListener('play', () => play.hidden = true);
    video.addEventListener('ended', () => play.hidden = false);
  });

  document.querySelectorAll('[data-tracking-form]').forEach(form => {
    const input = form.querySelector('input[name="nums"]');
    const error = form.querySelector('[data-tracking-error]');
    form.addEventListener('submit', event => {
      const value = String(input?.value || '').replace(/\s+/g, '').trim();
      const valid = /^[A-Za-z0-9-]{5,50}$/.test(value);
      if (!valid) {
        event.preventDefault();
        if (error) error.hidden = false;
        input?.focus();
        return;
      }
      if (input) input.value = value;
      if (error) error.hidden = true;
    });
  });

  document.querySelectorAll('[data-copy-code]').forEach(button => {
    button.addEventListener('click', async () => {
      const code = button.dataset.copyCode || '';
      const label = button.querySelector('[data-copy-label]');
      try {
        await navigator.clipboard.writeText(code);
        if (label) label.textContent = 'Copied';
      } catch (error) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
        if (label) label.textContent = 'Copied';
      }
    });
  });

  const launchDialog = document.querySelector('[data-launch-dialog]');
  if (launchDialog) {
    const success = launchDialog.querySelector('[data-launch-success]');
    const errors = launchDialog.querySelector('.errors');
    let launchOpened = false;
    let launchTimer;
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    let lastSeen = 0;
    try { lastSeen = Number(window.localStorage.getItem('sahovia-launch-seen') || 0); } catch (error) { /* storage is optional */ }
    const eligible = !lastSeen || Date.now() - lastSeen > sevenDays;
    const showLaunch = () => {
      if (launchOpened || launchDialog.open) return;
      if (document.querySelector('.sahovia-dialog[open]')) {
        launchTimer = window.setTimeout(showLaunch, 5000);
        return;
      }
      launchOpened = true;
      if (launchTimer) window.clearTimeout(launchTimer);
      window.removeEventListener('scroll', onLaunchScroll);
      openDialog(launchDialog);
    };
    const onLaunchScroll = () => {
      const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (window.scrollY / scrollable >= .5) showLaunch();
    };
    if (success || errors) {
      window.setTimeout(showLaunch, 180);
    } else if (eligible) {
      launchTimer = window.setTimeout(showLaunch, Math.max(10000, Number(launchDialog.dataset.delay || 35000)));
      window.addEventListener('scroll', onLaunchScroll, { passive: true });
    }
  }
})();
